/*
 * for the given date returns a date that is not included in the list of holidays or
 * a weekend.
 * @return boolean
 */
import moment from 'moment-timezone';

import dateIsInDateList from './dateIsInDateList';
import getNonWeekendDay from './getNonWeekendDay';

export default function getWorkingDay({
  holidays,
  date,
  timezone = moment.tz.guess(),
}) {
  let dateCopy = getNonWeekendDay({ date, timezone });
  let isHolidays = dateIsInDateList({
    date: dateCopy,
    dateList: holidays,
    timezone,
  });

  while (isHolidays) {
    dateCopy.add(1, 'day');
    dateCopy = getNonWeekendDay({ date: dateCopy });
    isHolidays = dateIsInDateList({ date: dateCopy, dateList: holidays });
  }

  return dateCopy;
}
